import React, { Component } from "react";
import { Header } from "../sections";
import { headerHeightMobile, headerHeight } from "../../constants";
import { useCommonWidths } from "../../hooks";
import { FormattedMessage } from "react-intl";
import { Typography, Grid } from "@material-ui/core";
import { navigate } from "@reach/router";
import { NetworkError } from "rest-hooks";

class ErrorBoundary extends Component<{}, { hasError: boolean }> {
	constructor(props: { fallback: any }) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error: Error) {
		const networkError = { ...error } as NetworkError;
		if (networkError.status === 401) {
			navigate("/logout", { state: { errorCode: networkError.status } });
			return;
		}
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: React.ErrorInfo) {
		logError(error, info);
	}

	render() {
		if (this.state.hasError) {
			return <ErrorPage />;
		}

		return this.props.children;
	}
}

const logError = (error: Error, info: React.ErrorInfo) => {
	console.error(
		`Error Occured! error: ${error}, componentStack: ${info.componentStack}`
	);
};

const ErrorPage = () => {
	const isMobile = useCommonWidths().isSmDown;
	return (
		<>
			<Header />
			<div
				style={{
					marginTop: isMobile ? headerHeightMobile : headerHeight,
				}}
			>
				<Grid
					alignContent="center"
					style={{ textAlign: "center", marginTop: 20 }}
					container
					spacing={3}
					direction="column"
				>
					<Grid item>
						<Typography variant="h4">
							<FormattedMessage
								id="minside.errorhandler.error"
								defaultMessage="Beklager! Her har det oppsått en feil."
								description="An error has occured"
							></FormattedMessage>
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="h5">
							<FormattedMessage
								id="minside.errorhandler.tryagain"
								defaultMessage="Vennligst prøv igjen"
								description="Please try again message"
							></FormattedMessage>
						</Typography>
					</Grid>
				</Grid>
			</div>
		</>
	);
};

export default ErrorBoundary;
